module.exports = __webpack_public_path__ + "static/media/DaytimeSleepiness.ea73510d.png";